import React from 'react';
import WithPatientFileHeader from '../../components/PatientFileHeader/WithPatientFileHeader';
import PatientProfile from '../../components/PatientProfile';

const AddOrEditPatient = () => {
    return (
        <>
            <PatientProfile />
        </>
    );
};

export default WithPatientFileHeader(AddOrEditPatient, ['newPatient'], false, 'white');
